import { NAV_LINKS } from '../utils/constants';
import routes from '../routes';

export default {
  computed: {
    links() {
      const landingLinks = NAV_LINKS.map(link => ({ name: 'home', title: link, hash: `#${link}` }));
      const routeLinks = routes.filter(route => route?.meta?.isNavLink);

      return [...landingLinks, ...routeLinks];
    },
  },
}